import React, { type ReactNode } from 'react';
import cn from 'classnames';

import { Header } from '../../../shared/components/header';

import styles from './index.module.css';

type Props = {
    children: ReactNode;
    topContent?: ReactNode;
    background?: boolean;
};

export const Layout = ({ children, topContent, background }: Props) => (
    <React.Fragment>
        <Header headerBg={background || !!topContent} />
        <section>
            {topContent && (
                <div className={styles.topContentBg}>
                    <div className={styles.topContent}>{topContent}</div>
                </div>
            )}
            <div className={cn(styles.contentBg, { [styles.background]: background })}>
                <div className={styles.content}>{children}</div>
            </div>
        </section>
    </React.Fragment>
);
